module.exports = __webpack_public_path__ + "static/media/doc2table_Logo.44332ee0.avif";